import ConnectStores from "lib/core/store/components/ConnectStores"
import withPathItemMutations from "../withPathItemMutations"
import PathGroupForm from "./PathGroupForm"

const mapStateToProps = function (state, ownProps) {
  const { selection } = state.pathAdminStore.state
  const { unSelectPathItem } = state.pathAdminStore.action

  const fieldValues = {
    name: selection.name,
    description: selection.description
  }

  const onCancel = () => unSelectPathItem()

  const onSubmit = function (fieldsData, resetForm) {
    const data = {
      name: fieldsData.name.value,
      description: fieldsData.description.value
    }
    return ownProps.savePathItem(data).then(() => unSelectPathItem())
  }

  const props = _.assign(
    {},
    {
      selection,
      fieldValues,
      onCancel,
      onSubmit
    },
    ownProps
  )
  return props
}

const stores = [{ store: "pathAdmin" }]

const PathGroupFormContainer = ConnectStores(
  PathGroupForm,
  stores,
  {},
  mapStateToProps
)
PathGroupFormContainer.displayName = "PathGroupFormContainer"
export default withPathItemMutations(PathGroupFormContainer)
